import { getSegmentId, getSegmentItems, isSeparateServiceSegment } from "./segmentFlow";
import { getCartCurrency } from "./cartCurrency";

const parse = (value) => {
  if (typeof value !== "string") return value;
  try { return JSON.parse(value); } catch { return null; }
};
const getValue = (source, keys) => {
  const key = keys.find((name) => source?.[name] !== null && source?.[name] !== undefined && source?.[name] !== "");
  return key ? source[key] : null;
};
export const hasCartId = (id) => id !== null && id !== undefined && String(id).trim() !== "" &&
  Number(id) !== 0 && !["null", "undefined", "false"].includes(String(id).trim().toLowerCase());

export const getSegmentCartInfo = (response) => {
  const segments = getSegmentItems(response);
  const result = { present: false, shopping: null, service: null, shoppingPresent: false, servicePresent: false };
  const sources = [response, response?.data, ...segments];

  sources.forEach((source) => {
    if (!source || typeof source !== "object") return;
    const key = ["cart_details", "cart_detail"].find((name) => Object.prototype.hasOwnProperty.call(source, name));
    if (!key) return;
    result.present = true;
    const value = parse(source[key]);
    const details = Array.isArray(value) ? value : [value];
    const markEmpty = () => {
      if (segments.includes(source)) {
        result[isSeparateServiceSegment(source) ? "servicePresent" : "shoppingPresent"] = true;
      } else {
        result.shoppingPresent = true;
        result.servicePresent = true;
      }
    };
    if (!details.length) markEmpty();
    details.forEach((detail) => {
      if (!detail || typeof detail !== "object") { markEmpty(); return; }
      const cartId = getValue(detail, ["cart_id", "cartId", "id"]);
      const segmentId = getValue(detail, ["segment_id", "segmentId", "segment"]) ||
        (segments.includes(source) ? getSegmentId(source) : null);
      const segment = segments.find((item) => String(getSegmentId(item)) === String(segmentId)) || {};
      const context = { ...segment, ...(segments.includes(source) ? source : {}), ...detail };
      const flow = isSeparateServiceSegment(context) ? "service" : "shopping";
      result[`${flow}Present`] = true;
      if (!hasCartId(cartId)) {
        if (!segmentId && context.segment_group_id === undefined) markEmpty();
        return;
      }
      const summary = {
        cart_id: cartId,
        product_count: Array.isArray(detail.product_details) ? detail.product_details.length : 0,
        product_details: Array.isArray(detail.product_details) ? detail.product_details : [],
        receipt: parse(detail.receipt) || null,
        currency: getCartCurrency(detail),
        segment_id: segmentId,
        business_segment_id: getValue(detail, ["business_segment_id", "cart_business_segment_id", "businessSegmentId", "store_id"]),
        store_name: getValue(detail, ["store_name", "business_segment_name", "business_name", "store_title"]),
        merchant_id: getValue(detail, ["merchant_id", "merchantId"]),
        segment_group_id: context.segment_group_id,
        segment_sub_group: context.segment_sub_group,
        title: context.title || context.segment_name || context.name || "Service",
        image: context.image || "",
      };
      result[flow] = summary;
    });
  });
  return result;
};
